import { SelectInputOption } from "@gx/dls/inputs/SelectInput";
import { Model } from "@gx/ts-contracts/services/database/models/public_pb";

import { type ProjectChatState } from "@/pages/projects/components/project/chat/types";

export enum ProjectChatVariant {
  WIDGET = "widget",
  PANEL = "panel",
}

export const DEFAULT_STATE: ProjectChatState = {
  messages: [],
  isLoading: false,
  isStreaming: false,
  inputValue: "",
  chatSessionId: undefined,
  needsHydration: false,
  model: Model.CLAUDE_SONNET_4_5,
};

export const MODEL_TO_NAME_MAP = {
  [Model.GPT_4_1]: "GPT-4.1",
  [Model.CLAUDE_SONNET_4_5]: "Claude Sonnet 4.5",
};

export const MODEL_SELECT_INPUT_OPTIONS: SelectInputOption[] = [
  {
    id: Model.GPT_4_1.toString(),
    label: MODEL_TO_NAME_MAP[Model.GPT_4_1],
    value: Model.GPT_4_1,
  },
  {
    id: Model.CLAUDE_SONNET_4_5.toString(),
    label: MODEL_TO_NAME_MAP[Model.CLAUDE_SONNET_4_5],
    value: Model.CLAUDE_SONNET_4_5,
  },
];

export const PRELOADED_PROMPTS = [
  "What are the most connected nodes in the graph?",
  "What node and edge types exist in this graph?",
  "What concepts does this context graph represent?",
];
